<!--Hotels -->
<div class="cart_item" [class.duplicate-item]="duplicateBooking">
  <div class="cart_item_wrapper">
    @if (hotel?.detail; as hotelDetail) {
      <div [class.duplicate-item-wrapper]="duplicateBooking">
        @if (duplicateBooking) {
          <div class="duplicate-item-date">
            <i class="ico-bed"></i>&nbsp;
            <span i18n="@@basketHotelCheckIn">Check-in:</span>
            @for (room of hotelDetail?.rooms; track room) {
              <div class="cart_item_hotel_dates">
                @if (room.checkIn && room.checkOut) {
                  <div>
                    @if (room.checkIn; as checkIn) {
                      <strong>{{ checkIn | sabsDate: 1 }}</strong>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        <div [class.duplicate-item-info]="duplicateBooking">
          @if (hotelDetail.hotelName || hotelDetail.hotelDescription; as hotelHeading) {
            <div class="cart_item_heading">
              @if (!duplicateBooking) {
                <i class="ico-bed"></i>&nbsp;
              }
              <strong>{{
                hotelDetail.hotelName || hotelDetail.hotelDescription | titlecase
              }}</strong>
              @if (!duplicateBooking) {
                <section (mouseleave)="tt1.close()">
                  <button
                    class="cart_item_remove ico-trash"
                    ngbTooltip="Remove  {{
                      hotelDetail.hotelName || hotelDetail.hotelDescription
                    }} from your {{ (displayItinerary ? 'itinerary' : 'basket') | translate }}"
                    attr.aria-label="Remove  {{
                      hotelDetail.hotelName || hotelDetail.hotelDescription
                    }} hotel from your {{
                      (displayItinerary ? 'itinerary' : 'basket') | translate
                    }}"
                    i18n-ngbTooltip
                    (click)="remove.emit()"
                    triggers="manual"
                    #tt1="ngbTooltip"
                    (mouseenter)="tt1.open()"
                    (focus)="tt1.open()"
                    (blur)="tt1.close()"
                    id="remove-basketitem-{{ hotelDetail.id }}"
                  ></button>
                </section>
              }
              @if (!duplicateBooking) {
                <section (mouseleave)="tt2.close()">
                  <img
                    src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                      displayItinerary ? 'luggage_icon' : 'basket_move'
                    }}.svg"
                    class="move_basket_icon"
                    role="button"
                    ngbTooltip="Move to different {{
                      (displayItinerary ? 'itinerary' : 'basket') | translate
                    }}"
                    i18n-ngbTooltip
                    attr.aria-label="Move  {{
                      hotelDetail.hotelName || hotelDetail.hotelDescription
                    }} hotel to different {{
                      (displayItinerary ? 'itinerary' : 'basket') | translate
                    }}"
                    (click)="openChangeModal.emit()"
                    (keydown.enter)="openChangeModal.emit()"
                    (keydown.space)="openChangeModal.emit()"
                    triggers="manual"
                    #tt2="ngbTooltip"
                    (mouseenter)="tt2.open()"
                    (focus)="tt2.open()"
                    (blur)="tt2.close()"
                    tabindex="0"
                    id="share-basketitem-{{ hotelDetail.id }}"
                  />
                </section>
              }
            </div>
          }
          @if (hotelDetail?.roomType; as roomType) {
            <div class="cart_item_hotel_room_type">
              <span i18n="@@basketPanelRoomType">Room type:</span>
              {{ roomType }}
            </div>
          }
          @if (hotelDetail?.numberOfRooms; as numberOfRooms) {
            <div class="cart_item_hotel_room_type">
              <span i18n="@@basketPanelNoOfRooms">No of rooms:</span>
              {{ numberOfRooms }}
            </div>
          }
          @if (hotelDetail?.hotelAddress; as hotelAddress) {
            <div class="cart_item_hotel_location">
              <span i18n="@@basketPanelHotelAddress">Address:</span>
              {{ getHotelAddress() }}
            </div>
          }
          @if (!duplicateBooking) {
            @for (room of hotelDetail?.rooms; track room) {
              <div class="cart_item_hotel_dates">
                @if (room.checkIn && room.checkOut) {
                  <div>
                    <span i18n="@@basketPanelParkingArrival">Check-in:</span>
                    {{ room.checkIn | sabsDate }}
                  </div>
                  <div>
                    <span i18n="@@itineraryHotelCheckOut">Check-out:</span>
                    {{ room.checkOut | sabsDate }}
                  </div>
                }
              </div>
            }
          }
        </div>
      </div>
    }
    @if (!duplicateBooking) {
      @for (user of travellers; track user) {
        <div class="traveller-name">
          <b>{{ user.forename }}, {{ user.surname }}</b>
        </div>
      }
    }
    @if (hotel.price >= 0) {
      <div class="cart_item_price">
        @if (duplicateBooking) {
          <strong i18n="@@basketPanelCostHotels">Cost</strong>
        }
        <strong>{{ hotel.price | currency: hotel.currency }}</strong>
        @if (hotel.convertedCurrencyCode) {
          <span class="converted_currency"
            >&nbsp;(<span i18n="@@ratesHotelApproxRate">Approx</span>:
            {{ hotel.convertedCurrencyAmount | currency: hotel.convertedCurrencyCode }})</span
          >
        }
        @if (!duplicateBooking) {
          <em i18n="@@basketPanelTotalPriceHotels">&nbsp;Total Price</em>
        }
      </div>
    }
  </div>
</div>
